import { Dispatch } from "redux"
import AxiosControl from '../../components/axios/AxiosControl'
const Axios = AxiosControl()

export const getClients = (page: number | null = null, limit: number | null = null, search: Object = '', sort: any = null) => async (dispatch: Dispatch) => {
    dispatch({ type: 'CLIENT_LOADING' })
    try {
        const { data, status } = await Axios.post('/api/client/getall/', { page, limit, search, sort }, {
            headers: { auth: localStorage.getItem('jwt'), ente: localStorage.getItem('enteId') }
        })
        if (status === 200) {
            dispatch({
                type: 'CLIENT_GETALL_SUCCESS',
                payload: data
            })
        } else {
            dispatch({ type: 'CLIENT_NOT_LOADING' })
        }
    } catch (error) {
        dispatch({ type: 'CLIENT_NOT_LOADING' })
    }
}

export const getForSelect = () => async (dispatch: Dispatch) => {
    dispatch({ type: 'CLIENT_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/client/getforselect/', {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'CLIENT_GETALLFORSELECT_SUCCESS',
                payload: data
            })
        } else {
            dispatch({ type: 'CLIENT_NOT_LOADING' })
        }
    } catch (error) {
        dispatch({ type: 'CLIENT_NOT_LOADING' })
    }
}

export const getClient = (client: string) => async (dispatch: Dispatch) => {
    dispatch({ type: 'CLIENT_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/client/get/' + client, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'CLIENT_GET_SUCCESS',
                payload: data
            })
        } else {
            dispatch({ type: 'CLIENT_NOT_LOADING' })
        }
    } catch (error) {
        dispatch({ type: 'CLIENT_NOT_LOADING' })
    }
}

export const readClient = (idClient: string) => async (dispatch: Dispatch) => {
    dispatch({
        type: 'CLIENTDATA_LOADING'
    })    
    try {
        const { data, status } = await Axios.get('/api/client/readClient/' + idClient, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200 || status === 304) {
            dispatch({
                type: 'CLIENTDATA_GET_SUCCESS',
                payload: data
            })
        } else {
            dispatch({
                type: 'CLIENTDATA_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'CLIENTDATA_NOT_LOADING'
        })
    }
}

export const editClient = (client: any, id?: string) => async (dispatch: Dispatch) => {
    dispatch({ type: 'CLIENT_LOADING' })
    try {
        const { data, status } = await Axios.put('/api/client/edit/' + id, client, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200 || status === 264 || status === 260) {
            dispatch({
                type: 'CLIENT_EDIT_SUCCESS',
                payload: { message: data.message, id, updatedClient: client }
            })
        } else {
            dispatch({ type: 'CLIENT_NOT_LOADING' })
        }
    } catch (error) {
        dispatch({ type: 'CLIENT_NOT_LOADING' })
    }
}

export const createCode = (dni: string) => async (dispatch: Dispatch) => {
    dispatch({ type: 'CLIENT_LOADING' })
    try {
        const { data, status } = await Axios.put('/api/payment/code/' + dni, {}, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'CLIENT_CODE_SUCCESS',
                payload: { message: data.message, id: dni }
            })
        } else {
            dispatch({ type: 'CLIENT_CODE_ERROR', payload: { message: status === 404 ? 'clientNotFound' : 'serverError' } })
        }
    } catch (error: any) {
        dispatch({ type: 'CLIENT_CODE_ERROR', payload: { message: error.response?.data?.message || 'error' } })
    }
}